module.exports = __webpack_public_path__ + "img/documentation.0e0585e2.svg";